import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Navigation bar for main domain (marketing pages)
 */
const MainDomainNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: 'Why', path: '/why' },
    { label: 'Platform', path: '/platform' },
    { label: 'Solutions', path: '/solutions' },
    { label: 'Pricing', path: '/pricing' },
  ];

  return (
    <AppBar position="fixed" elevation={1} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: '#060a33' }}>
      <Toolbar sx={{ 
        justifyContent: 'space-between', 
        paddingLeft: '0 !important', 
        minHeight: '64px !important',
        maxHeight: '64px !important',
        height: '64px !important',
        overflow: 'visible',
      }}>
        {/* Left Section - Logo and Brand */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, pl: 1.5, height: '100%', overflow: 'visible' }}>
          <Box
            component="img"
            src="/dragonfly-mark.jpg"
            alt="CRUD Expert"
            sx={{
              width: 36,
              height: 43,
              objectFit: 'contain',
              borderRadius: '8px',
              flexShrink: 0,
              display: 'block',
              cursor: 'pointer',
            }}
            onClick={() => navigate('/')}
          />
          <Typography 
            variant="h6" 
            noWrap 
            component="div" 
            sx={{ 
              fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
              fontSize: '18px',
              fontWeight: 700,
              lineHeight: 1.15,
              cursor: 'pointer',
              color: '#fff',
            }}
            onClick={() => navigate('/')}
          >
            CRUD EXPERT
          </Typography>
        </Box>

        {/* Right Section - Navigation Items */}
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          {navItems.map((item) => (
            <Button
              key={item.path}
              color="inherit"
              onClick={() => navigate(item.path)}
              sx={{
                color: location.pathname === item.path ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.7)',
                fontWeight: location.pathname === item.path ? 600 : 400,
                '&:hover': {
                  color: 'rgba(255, 255, 255, 1)',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              {item.label}
            </Button>
          ))}
          <Button
            variant="outlined"
            onClick={() => navigate('/login')}
            sx={{
              color: 'white',
              borderColor: 'rgba(255, 255, 255, 0.5)',
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            Sign In
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate('/signup')}
            sx={{
              backgroundColor: 'white',
              color: 'primary.main',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
              },
            }}
          >
            Get Started
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MainDomainNav;

